export default {
  image: 'Billedet',
  audio: 'Lydfilen',
  video: 'Videoen',
  document: 'Filen',
  file_scan_blocked_image: 'Billedet kunne ikke uploades, da det blev afvist i filscanning.',
  file_scan_blocked_audio: 'Lydfilen kunne ikke uploades, da den blev afvist i filscanning.',
  file_scan_blocked_video: 'Videoen kunne ikke uploades, da den blev afvist i filscanning.',
  file_scan_blocked_document: 'Filen kunne ikke uploades, da den blev afvist i filscanning.',
  file_scan_blocked_short: 'Afvist i filscanning',
  file_scan_processing_image: 'Billedet behandles. Vend tilbage om et øjeblik.',
  file_scan_processing_audio: 'Lydfilen behandles. Vend tilbage om et øjeblik.',
  file_scan_processing_video: 'Videoen behandles. Vend tilbage om et øjeblik.',
  file_scan_processing_document: 'Filen behandles. Vend tilbage om et øjeblik.',
  file_scan_processing_image_short: 'Billedet behandles',
  file_scan_processing_audio_short: 'Lydfilen behandles',
  file_scan_processing_video_short: 'Videoen behandles',
  file_scan_processing_document_short: 'Filen behandles',
  file_was_rejected: 'Din fil blev afvist.',
  go_to_file: 'Gå til filen for at prøve igen.',
  drop_file_here: 'Vedhæft filer ved at slippe dem her.',
  files_attached: 'Filer er vedhæftet.',
};
